import apiClient from '@/lib/apiClient';

/**
 * /health answers with a bare object rather than the usual { success, data }
 * envelope, so it is typed here instead of through ApiResponse.
 */
interface HealthResponse {
  success: boolean;
  message: string;
  timestamp: string;
  // Absent on a server older than this field; treated as "not dev".
  devMode?: boolean;
}

export const healthService = {
  /** Whether the API is running with NODE_ENV=development. */
  getDevMode: async (): Promise<boolean> => {
    const { data } = await apiClient.get<HealthResponse>('/health');
    return data.devMode === true;
  },
};
